class meter_management_create_request_type_2_datetimepicker extends Tango.Component {
    widgetDidMount() {
        var extraIcon = document.getElementById("metermanagementrequestcreate_btnactivationdatetime_dperiodfrom");
        if (extraIcon) {
            extraIcon.remove();
        }
        else {
            setTimeout(() => {
                extraIcon = document.getElementById("metermanagementrequestcreate_btnactivationdatetime_dperiodfrom");
                if (extraIcon) {
                    extraIcon.remove();
                }
            }, 0)
        }

        var icon = document.getElementById("metermanagementrequestcreate_activationdatetime_btn");
        if (icon) {
            icon.style = "position: relative; order: 1; margin-left: 312px;";
        }
        else {
            setTimeout(() => {
                icon = document.getElementById("metermanagementrequestcreate_activationdatetime_btn");
                if (icon) {
                    icon.style = "position: relative; order: 1; margin-left: 312px;";;
                }
            }, 0)
        }

        var timeSelects = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime");
        if (timeSelects) {
            timeSelects.style = "width: 55px; margin-left: -336.8px; border: none; background-color: #EBF3FF; border-top-right-radius: 15px; border-bottom-right-radius: 15px; "
        }
        else {
            setTimeout(() => {
                timeSelects = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime");
                if (timeSelects) {
                    timeSelects.style = "width: 55px; margin-left: -336.8px; border: none; background-color: #EBF3FF; border-top-right-radius: 15px; border-bottom-right-radius: 15px; "
                }
            }, 0);
        }

        var hourSelect = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime_hour");
        if (hourSelect) {
            hourSelect.style = "border: none; background-color: #EBF3FF;";
        }
        else {
            setTimeout(() => {
                hourSelect = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime_hour");
                if (hourSelect) {
                    hourSelect.style = "border: none; background-color: #EBF3FF;";
                }
            }, 0);
        }

        var minuteSelect = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime_minute");
        if (minuteSelect) {
            minuteSelect.style = "border: none; background-color: #EBF3FF;";
        }
        else {
            setTimeout(() => {
                minuteSelect = document.getElementById("metermanagementrequestcreate_activationdatetime_dperiodfromtime_minute");
                if (minuteSelect) {
                    minuteSelect.style = "border: none; background-color: #EBF3FF;";
                }
            }, 0);
        }
    };
};
Tango.registerComponent(meter_management_create_request_type_2_datetimepicker, sp => ({
    cu: sp.commonUtils,
    au: sp.ajaxUtils,
}));